module.exports = __webpack_public_path__ + "static/media/top_banner_4.96a24601.png";